/**
 * Product language standard (display strings only).
 *
 * - PRODUCT_NAME  → the app/product itself.
 * - COMMUNITY_NAME → the people/community.
 *
 * Legal / business-entity copy (Privacy Policy, Terms, support email subjects)
 * intentionally keeps the registered business name and is not covered here.
 */
export const PRODUCT_NAME = "Wellness Cowgirl";
export const COMMUNITY_NAME = "Wellness Cowgirls";

/** "1 Event" / "2 Events" */
export const pluralizeEvents = (count: number) =>
  `${count} ${count === 1 ? "Event" : "Events"}`;

/**
 * `profiles.monthly_event_count` is maintained by a database trigger and only
 * resets when a new attendance is recorded. `monthly_event_month` records which
 * month the count belongs to, so a stale value must not be shown as "this month".
 * Display only — this never writes to the profile.
 */
export const currentMonthAttendedCount = (profile?: {
  monthly_event_count?: number | null;
  monthly_event_month?: string | null;
} | null): number => {
  const count = profile?.monthly_event_count ?? 0;
  if (!count) return 0;

  const month = profile?.monthly_event_month;
  if (!month) return 0;

  // Current month in America/Chicago (San Antonio).
  const now = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
  }).format(new Date());

  return month.slice(0, 7) === now.slice(0, 7) ? count : 0;
};
